import { AchPaymentStatusTotalDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

const defaultAchPaymentStatusTotalDto: AchPaymentStatusTotalDto = {};

export class AchPaymentTotals extends DomainEntity<AchPaymentStatusTotalDto> {
    public createDefault(): this {
        return new AchPaymentTotals(defaultAchPaymentStatusTotalDto) as this;
    }

    public get status() {
        return this.dto.status ?? '';
    }

    public set status(value: string) {
        this.dto.status = value;
    }

    public get count() {
        return this.dto.count ?? 0;
    }

    public set count(value: number) {
        this.dto.count = value;
    }

    public get totalCredit() {
        return this.dto.totalCredit ?? 0;
    }

    public set totalCredit(value: number) {
        this.dto.totalCredit = value;
    }

    public get totalDebit() {
        return this.dto.totalDebit ?? 0;
    }

    public set totalDebit(value: number) {
        this.dto.totalDebit = value;
    }
}
